//const API_BASE_URL = "http://127.0.0.1:8000/api";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
class CustomerNotesService {
  async saveCustomerNotes(data) {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-notes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
           'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.message || "Failed to save customer notes");

      return result;
    } catch (error) {
      console.error("Error saving customer notes:", error);
      throw error;
    }
  }

  async updateCustomerNotes(id, data) {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-notes/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.message || "Failed to update customer notes");

      return result;
    } catch (error) {
      console.error("Error updating customer notes:", error);
      throw error;
    }
  }

  async getCustomerNotesByConnectionId(connectionId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/customer-notes/connection/${connectionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
           "Accept": "application/json",
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
        }
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.message || "Failed to fetch customer notes");

      return result;
    } catch (error) {
      console.error("Error fetching customer notes:", error);
      throw error;
    }
  }

  async requestRateReduction(data) {
    try {
      const response = await fetch(`${API_BASE_URL}/rate-reduction-requests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
           'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "Failed to create rate reduction request"
        );

      return result;
    } catch (error) {
      console.error("Error creating rate reduction request:", error);
      throw error;
    }
  }

  async getRateReductionRequests(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE_URL}/rate-reduction-requests${
        queryString ? "?" + queryString : ""
      }`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "Failed to fetch rate reduction requests"
        );

      return result;
    } catch (error) {
      console.error("Error fetching rate reduction requests:", error);
      throw error;
    }
  }

  async approveRateReduction(id, data = {}) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/rate-reduction-requests/${id}/approve`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
             'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "Failed to approve rate reduction request"
        );

      return result;
    } catch (error) {
      console.error("Error approving rate reduction request:", error);
      throw error;
    }
  }

  async rejectRateReduction(id, data) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/rate-reduction-requests/${id}/reject`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
             'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "Failed to reject rate reduction request"
        );

      return result;
    } catch (error) {
      console.error("Error rejecting rate reduction request:", error);
      throw error;
    }
  }

  async getMyRateReductionRequests(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE_URL}/rate-reduction-requests/my-requests${
        queryString ? "?" + queryString : ""
      }`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
           'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      const result = await response.json();
      if (!response.ok)
        throw new Error(
          result.message || "Failed to fetch your rate reduction requests"
        );

      return result;
    } catch (error) {
      console.error("Error fetching your rate reduction requests:", error);
      throw error;
    }
  }

  async getRateReductionStatistics() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/rate-reduction-requests/statistics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
             'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
        }
      );

      const result = await response.json();
      if (!response.ok)
        throw new Error(result.message || "Failed to fetch statistics");

      return result;
    } catch (error) {
      console.error("Error fetching statistics:", error);
      throw error;
    }
  }
}

const customerNotesService = new CustomerNotesService();
export default customerNotesService;
